import * as React from "react";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import {
  HowToReg,
  LocalOffer,
  PermContactCalendar,
  SupervisedUserCircle,
} from "@mui/icons-material";
import Contactos from "./Contactos";
import TiposContacto from "./TipoContacto";
import StatusContacto from "./StatusContacto";
import EtiquetasContacto from "./Etiquetas";

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`tabpanel-tratos-${index}`}
      aria-labelledby={`tab-tratos-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ pt: 1 }}>{children}</Box>}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `tab-tratos-${index}`,
    "aria-controls": `tabpanel-tratos-${index}`,
  };
}

export default function ContactoIndex() {
  const [value, setValue] = React.useState(0);

  const handleChange = (_, newValue) => {
    setValue(newValue);
  };

  return (
    <Box
      sx={{
        width: "100%",
        //border: "1px solid red",
        height: { xs: `calc(100vh - 120px)`, md: `calc(100vh - 74px)` },
      }}
    >
      <Tabs
        value={value}
        onChange={handleChange}
        variant="scrollable"
        sx={{
          minHeight: "auto",
          "& .MuiButtonBase-root": {
            minHeight: "auto",
            py: {xs: 1.3, md: 0},
            pb: {md: 1},
            textTransform: "none",
          },
          borderBottom: "1px solid",
          borderColor: "divider"
        }}
      >
        <Tab
          icon={<PermContactCalendar />}
          iconPosition="start"
          label="Contactos"
          {...a11yProps(0)}
        />
        <Tab
          icon={<SupervisedUserCircle />}
          iconPosition="start"
          label="Tipos"
          {...a11yProps(1)}
        />
        <Tab
          icon={<HowToReg />}
          iconPosition="start"
          label="Status"
          {...a11yProps(2)}
        />
        <Tab
          icon={<LocalOffer />}
          iconPosition="start"
          label="Etiquetas"
          {...a11yProps(3)}
        />
      </Tabs>
      <Box>
        <CustomTabPanel value={value} index={0}>
          <Contactos />
        </CustomTabPanel>
        <CustomTabPanel value={value} index={1}>
          <TiposContacto />
        </CustomTabPanel>
        <CustomTabPanel value={value} index={2}>
          <StatusContacto />
        </CustomTabPanel>
        <CustomTabPanel value={value} index={3}>
          <EtiquetasContacto />
        </CustomTabPanel>
      </Box>
    </Box>
  );
}
